import { useMutation, useQueryClient, type MutationMeta } from '@tanstack/react-query';
import type { IIssue } from '../../../trusstor/index.js';
import { useClientApis } from '../../hooks/ClientApisProvider.js';
import { issuesKeys } from '../queryKeys.js';

/** `meta`: the mutation's react-query meta — `OWNS_ERROR_FEEDBACK` when the caller reports a failure itself. */
export function useCreateIssue(siteId: string | null, meta?: MutationMeta) {
  const { createIssueApi } = useClientApis().issues;
  const qc = useQueryClient();
  return useMutation({
    meta,
    mutationFn: (body: Partial<IIssue>) => {
      if (!siteId) throw new Error('createIssue called without siteId');
      return createIssueApi(siteId, body);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: issuesKeys.list(siteId) });
    },
  });
}
